import React from 'react';

export default function StudentModule({ module }) {
  if (module === 'profile') return <StudentProfile />;
  if (module === 'attendance') return <AttendanceTracker />;
  if (module === 'timetable') return <Timetable />;
  if (module === 'grades') return <GradesReports />;
  return null;
}

function StudentProfile() {
  return (
    <div className="dash-page">
      <h1>Student Profile & Academic History</h1>
      <div className="profile-card">
        <div className="profile-header">
          <div className="avatar">👨‍🎓</div>
          <div>
            <h2>Aarav Sharma</h2>
            <p>B.Sc Nursing | Roll: NS2024001 | Academic Year: 2025-2026</p>
          </div>
        </div>
        <div className="profile-tabs">
          <button className="tab active">Personal Info</button>
          <button className="tab">Attendance Records</button>
          <button className="tab">Fee Status</button>
          <button className="tab">Scorecard</button>
        </div>
        <div className="profile-content">
          <p><strong>DOB:</strong> 12 Mar 2004 | <strong>Blood:</strong> O+</p>
          <p><strong>Address:</strong> 123 Healthcare Ave, New Delhi</p>
          <p><strong>Guardian:</strong> Mr. R. Sharma (+91 9876543210)</p>
        </div>
      </div>
    </div>
  );
}

function AttendanceTracker() {
  const [records] = React.useState([
    { date: '2026-04-10', status: 'Present' },
    { date: '2026-04-09', status: 'Present' },
    { date: '2026-04-08', status: 'Absent' },
  ]);
  return (
    <div className="dash-page">
      <h1>Automated Attendance Tracking</h1>
      <table className="data-table">
        <thead><tr><th>Date</th><th>Status</th><th>Remarks</th></tr></thead>
        <tbody>
          {records.map((r,i) => (
            <tr key={i}><td>{r.date}</td><td><span className={`badge ${r.status==='Present'?'green':'red'}`}>{r.status}</span></td><td>-</td></tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function Timetable() {
  const days = ['Mon','Tue','Wed','Thu','Fri','Sat'];
  const slots = ['09:00-10:00','10:00-11:00','11:15-12:15','13:00-14:00','14:00-15:00'];
  return (
    <div className="dash-page">
      <h1>Class Timetable & Scheduling</h1>
      <div className="tt-table">
        <div className="tt-header"><span>Day/Time</span>{slots.map(s=><span key={s}>{s}</span>)}</div>
        {days.map(d=>(
          <div key={d} className="tt-row"><span className="day-label">{d}</span>{slots.map((_,i)=>(<span key={i} className="tt-cell">Subject {i+1}</span>))}</div>
        ))}
      </div>
    </div>
  );
}

function GradesReports() {
  return (
    <div className="dash-page">
      <h1>Grade Management & Report Cards</h1>
      <div className="grade-summary">
        <div className="g-box"><h4>CGPA</h4><p>8.92</p></div>
        <div className="g-box"><h4>Semester 5</h4><p>9.1</p></div>
        <div className="g-box"><h4>Attendance</h4><p>94%</p></div>
      </div>
      <table className="data-table">
        <thead><tr><th>Subject</th><th>Internal</th><th>External</th><th>Grade</th></tr></thead>
        <tbody>
          <tr><td>Anatomy</td><td>88</td><td>92</td><td>A</td></tr>
          <tr><td>Pharmacology</td><td>76</td><td>84</td><td>B+</td></tr>
        </tbody>
      </table>
      <button className="btn btn-primary" style={{marginTop:15}}>📥 Download Report Card</button>
    </div>
  );
}